module.exports = __webpack_public_path__ + "static/person_chopping_veggies_mobile-1d2d95db0bb454396acbded08cab50c3.png";